import Link from 'next/link';
import { memo } from 'react';
import styled from 'styled-components';

import { Flexbox, HorizontalSeparator, Typography } from '@seuk/design-system/atoms';
import { DateFormat, formatDate } from '@seuk/util';

interface PressArticle {
  title: string;
  date: string;
  description: string;
  slug: string;
}

export interface PressArticlesProps {
  articles: PressArticle[];
}

const StyledArticle = styled(Flexbox)`
  gap: ${({ theme }) => theme.spacing(2)};
  flex-direction: column;
`;

const Article = ({ title, date, slug, description }: PressArticle) => {
  return (
    <StyledArticle>
      <div>{formatDate(new Date(date), DateFormat.fullShortMonth)}</div>
      <Link href={`/press/articles/${slug}`}>{title}</Link>
      <Typography>{description}</Typography>
      <HorizontalSeparator />
    </StyledArticle>
  );
};

const StyledPressArticles = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing(40)};
`;

const ArticlesTitle = styled(Typography)`
  margin-bottom: ${({ theme }) => theme.spacing(8)};
`;

const ArticlesContainer = styled(Flexbox)`
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(4)};
`;

export const PressArticles = memo(({ articles }: PressArticlesProps) => {
  return (
    <StyledPressArticles>
      <ArticlesTitle variant="h3" component="h2">
        Press releases
      </ArticlesTitle>
      <ArticlesContainer>
        {articles.map((article) => {
          return <Article key={article.slug} {...article} />;
        })}
      </ArticlesContainer>
    </StyledPressArticles>
  );
});

PressArticles.displayName = 'PressArticles';
